var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgMissionIcon2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 61,
    viewBox: "0 0 60 61",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.6996 38.45V48.8H13.8996V32.7H27.6996V38.45ZM34.5996 39.6H32.2996V32.7H46.0996V39.6H43.7996V51.1H50.6996V27.4849L29.9996 10.0535L9.29961 27.4849V51.1H34.5996V39.6ZM52.2702 25.8H55.3003V24.5771L30.0003 3.49464L4.70027 24.5771V25.8H7.73035L30.0009 7.04646L52.2702 25.8ZM6.99961 41.9V44.2H2.39961V58H57.5996V44.2H52.9996V41.9H59.8996V60.3H0.0996094V41.9H6.99961ZM2.39961 23.5L29.9996 0.5L57.5996 23.5V28.1H52.9996V53.4H6.99961V28.1H2.39961V23.5ZM36.8996 51.1H41.4996V39.6H36.8996V51.1ZM34.5996 37.3H43.7996V35H34.5996V37.3ZM16.1996 37.3H25.3996V35H16.1996V37.3ZM16.1996 46.5H25.3996V39.6H16.1996V46.5Z",
    fill: "white"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMissionIcon2);
export default __webpack_public_path__ + "static/media/mission-icon2.ade79129743e92544c115e2d368a2b6f.svg";
export { ForwardRef as ReactComponent };